<div class="flex flex-col bg-surface-50 dark:bg-surface-950  h-full overflow-hidden">
    <div class="flex flex-col gap-3 p-3">
        <div class="flex flex-col xl:flex-row gap-3 xl:h-[calc(100vh-5.5rem)]">
            <!-- Document Types Section -->
            <app-document-types-list [documentTypes]="documentTypes" [docTypeLoading]="documentTypeLoading"
                class="w-full lg:w-[20rem] flex flex-col gap-2 overflow-y-auto overflow-x-hidden min-h-0 max-h-[calc(100vh-4rem)] flex-shrink-0"
                (documentTypeSelected)="selectDocumentType($event)" (refetchDocumentTypes)="getDocumentTypes()">
            </app-document-types-list>

            <!-- Knowledge Mapping Section -->
            <div class="w-full xl:flex-1 flex flex-col gap-3 min-h-[50vh] xl:min-h-0 overflow-x-scroll">
                <div class="flex-1 overflow-y-auto scrollbar-thin max-h-[calc(100vh-4rem)] xl:max-h-full">
                    @if(linkedDocsLoading){
                    <div class="skeleton-card">
                        <div class="border-round border-1 surface-border surface-card p-4 h-full">
                            <div class="flex flex-col gap-4 h-full">
                                @for (item of getSkeletonCount(); track $index) {
                                <div class="w-full h-20">
                                    <p-skeleton width="auto" height="100%" />
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                    }
                    @else {
                    <div
                        class="flex flex-col gap-2 justify-between w-fit xl:w-full h-full overflow-x-hidden min-h-0 max-h-[calc(100vh-4rem)]">
                        @if(selectedKnowledgeBase){
                        <div class="flex justify-between items-center">
                            <app-button variant="outlined" [label]="selectedKnowledgeBase.name"
                                icon="pi pi-chevron-left" (clicked)="toggleKb()" />
                        </div>
                        } @else {
                        <div class="flex items-cente gap-1">
                            <span
                                class="text-surface-900 dark:text-surface-0 font-semibold text-lg xl:text-2xl">{{selectedDocumentType?.name}}</span>
                            <span class="text-gray-500 font-semibold text-lg lg:text-2xl">
                                ({{filteredLinkedDocs.length}})</span>

                        </div>
                        }

                        <div class="flex-shrink-0">

                            @if(selectedKnowledgeBase && selectedKbFiles.length > 0){
                            <div
                                class="flex flex-col sm:flex-row gap-2 p-2 border rounded-base shadow-sm mb-2 items-start sm:items-center">
                                <p class="text-xs sm:text-sm font-medium">{{selectedKbFiles.length}} files selected</p>
                                <div class="hidden sm:block h-6 w-px bg-gray-300 mx-2"></div>

                                <app-button variant="outlined" icon="pi pi-download" class="text-sm"
                                    (clicked)="downloadSelectedItems()" [loading]="downloadLoading" />

                                <div class="hidden sm:block h-6 w-px bg-gray-300 mx-2"></div>

                                <app-button variant="outlined" icon="pi pi-file-import" severity="danger"
                                    label="Delink files" (clicked)="delinkKbFiles()" class="text-sm" />
                            </div>
                            }

                            <div class="flex flex-col sm:flex-row items-start sm:items-baseline gap-2 mb-2">
                                <app-button variant="filled" severity="primary" label="Mapping" icon="pi pi-plus"
                                    (clicked)="openMappingDialog()" />
                                <app-search-bar placeholder="File or knowledge base name" width="100%"
                                    [(ngModel)]="searchLinkedDocs"
                                    (searchChange)="onLinkedDocsSearch()"></app-search-bar>
                            </div>

                        </div>

                        <div class="h-full flex-1 min-h-0 overflow-hidden">
                            @if(!selectedKnowledgeBase && filteredLinkedDocs.length > 0 && selectedLinkedDocs.length >
                            0){
                            <div
                                class="flex flex-col sm:flex-row gap-2 p-2 border rounded-base shadow-sm mb-2 items-start justify-between sm:items-center">
                                <div class="flex items-center gap-2">
                                    <p class="text-xs sm:text-sm font-medium">{{selectedLinkedDocs.length}} items
                                        selected
                                    </p>
                                    <div class="hidden sm:block h-6 w-px bg-gray-300 mx-2"></div>

                                    <app-button variant="outlined" icon="pi pi-download" class="text-sm"
                                        (clicked)="downloadSelectedItems()" [loading]="downloadLoading" />
                                </div>
                                <div class="border rounded-md flex gap-2 px-2 py-1 items-center cursor-pointer"
                                    (click)="delinkFiles()">
                                    <span>
                                        <i [innerHTML]="SVGS.BULK_DELINK | sanitizeHtml" alt="" width="24"
                                            height="24"></i>
                                    </span>
                                    Delink from knowledge mapping
                                </div>
                            </div>
                            }
                            <div class="flex-1 flex flex-col min-h-0 h-full overflow-hidden overflow-x-auto">
                                @if(selectedDocumentType && getTableData().length){
                                <app-data-table class="" [data]="getTableData()" [columns]="currentTableColumns"
                                    [config]="tableConfig" dataKey="_id"
                                    (selectionChange)="onTableSelectionChange($event)"
                                    [tableClass]="'rounded-base text-sm'" [customTemplates]="templatesMap">
                                </app-data-table>
                                } @else {
                                <div class="flex flex-col gap-4 justify-center items-center h-full w-full">
                                    <p class="text-center text-gray-500">{{"no documents found" | titlecase}}</p>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>

<app-dialog [(visible)]="showMappingDialog" title="Map File" (closed)="hideMappingDialog()"
    class="max-w-[75rem] h-[80vh]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        @if(mappingDialogLoading){
        <p-skeleton width="100%" height="100%" />
        }
        @else{
        <div class="h-full flex flex-row gap-4 py-2 overflow-y-auto">
            <div class="flex flex-col flex-1 min-w-0 min-h-0 overflow-hidden">
                <p-tabs [value]="activeIndex.toString()" (valueChange)="onTabChange($event)"
                    class=" flex flex-col h-full overflow-hidden">
                    <p-tablist class="flex-shrink-0 map-files-tablist">
                        <p-tab *ngFor="let tab of tabs; let i = index" [value]="i.toString()"
                            class="flex items-center !gap-2 px-2 py-1">
                            <span class="truncate text-sm">{{ tab.title }}</span>
                        </p-tab>
                    </p-tablist>
                    <p-tabpanels class="flex-1 min-h-0 overflow-hidden">
                        <p-tabpanel *ngFor="let tab of tabs; let i = index" [value]="i.toString()" class="h-full">
                            <div class="flex flex-col h-full">
                                @if(tab.type === LINKED_DOCUMENT_TYPE.KNOWLEDGE_BASE_STORE){
                                @if(selectedKbInMapping){
                                <div class="flex flex-row justify-between items-center mb-3">
                                    <app-button variant="outlined" [label]="selectedKbInMapping.name"
                                        icon="pi pi-chevron-left" (clicked)="toggleKbInMapping()" />
                                </div>
                                }
                                <div class="mb-3">
                                    <app-search-bar placeholder="Search with name" width="100%"
                                        [(ngModel)]="searchKbStores"
                                        (searchChange)="onKbStoresSearch()"></app-search-bar>
                                </div>
                                @if(!selectedKbInMapping){
                                <div class="mb-3">
                                    <div class="flex items-center gap-2">
                                        <app-checkbox [value]="getSelectAllValue('kbStores')"
                                            (onChange)="toggleSelectAll('kbStores', $event)"
                                            [config]="{ binary: true, label: 'Select all (' + filteredKbStores.length + ')' }"></app-checkbox>
                                    </div>
                                </div>
                                }
                                <div class="flex-1 overflow-y-auto max-h-[calc(100vh-33rem)]">
                                    @if(selectedKbInMapping){
                                    <div class="flex flex-col gap-2">
                                        <div *ngFor="let item of selectedKbInMapping.files"
                                            class="border border-gray-200 rounded-lg p-3 hover:bg-gray-50 bg-white">
                                            <div class="flex items-center gap-3 min-w-0">
                                                <div class="flex-shrink-0">
                                                    @if(item.file.mimeType == "pdf"){
                                                    <i [innerHTML]="SVGS.PDF | sanitizeHtml" alt="" width="24"
                                                        height="24"></i>
                                                    }@else if (item.file.mimeType == "docx") {
                                                    <i [innerHTML]="SVGS.DOCX | sanitizeHtml" alt="" width="24"
                                                        height="24"></i>
                                                    }
                                                </div>
                                                <div class="min-w-0 flex-1">
                                                    <div class="text-sm font-medium text-gray-900 truncate"
                                                        pTooltip="{{ item.file.name }}" tooltipPosition="top">
                                                        {{ item.file.name }}
                                                    </div>
                                                    <div class="text-xs text-gray-500 truncate">{{ item.file.size }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    } @else {
                                    <div class="flex flex-col gap-2">
                                        @if(filteredKbStores.length === 0){
                                        <div class="flex flex-col items-center justify-center py-12 text-center">
                                            <p class="text-sm text-gray-500">No files found.</p>
                                        </div>
                                        } @else {
                                        <div *ngFor="let item of filteredKbStores"
                                            class="border border-gray-200 rounded-lg p-3 hover:bg-gray-50 transition-colors bg-white">
                                            <div class="flex items-center gap-3 min-w-0">
                                                <app-checkbox [value]="selectedItemsIdsSet.has(item._id)"
                                                    (onChange)="toggleSelect('kbStores', item)"
                                                    [config]="{ binary: true }" class="flex-shrink-0" />
                                                <div class="flex-shrink-0 cursor-pointer"
                                                    (click)="toggleKbInMapping(item)">
                                                    <i [innerHTML]="SVGS.KNOWLEDGE_BASE | sanitizeHtml" alt=""
                                                        width="24" height="24"></i>
                                                </div>
                                                <div class="min-w-0 flex-1 cursor-pointer"
                                                    (click)="toggleKbInMapping(item)">
                                                    <div class="text-sm font-semibold text-gray-900 truncate"
                                                        pTooltip="{{ item.name }}" tooltipPosition="top">
                                                        {{ item.name }}
                                                    </div>
                                                    <div class="text-xs text-gray-500 truncate">
                                                        {{ item.description || '' }}
                                                    </div>
                                                </div>
                                                <span class="text-xs text-gray-500 flex-shrink-0">{{
                                                    getKbStoreFileCount(item) }} files</span>
                                            </div>
                                        </div>
                                        }
                                    </div>
                                    }
                                </div>

                                } @else {

                                <div class="mb-3">
                                    <app-search-bar placeholder="Search with name" width="100%"
                                        [(ngModel)]="searchKbFiles" (searchChange)="onKbFilesSearch()"></app-search-bar>
                                </div>

                                <div class="mb-3">
                                    <div class="flex items-center gap-2">
                                        <app-checkbox [value]="getSelectAllValue('kbFiles')"
                                            (onChange)="toggleSelectAll('kbFiles', $event)"
                                            [config]="{ binary: true, label: 'Select all (' + filteredKbFiles.length + ')' }"></app-checkbox>
                                    </div>
                                </div>

                                <div class="flex-1 overflow-y-auto max-h-[calc(100vh-33rem)]">
                                    @if(filteredKbFiles.length === 0){
                                    <div class="flex flex-col items-center justify-center py-12 text-center">
                                        <p class="text-sm text-gray-500">No files found.</p>
                                    </div>
                                    } @else {
                                    <div class="flex flex-col gap-2">
                                        <div *ngFor="let item of filteredKbFiles"
                                            class="border border-gray-200 rounded-lg p-3 hover:bg-gray-50 transition-colors bg-white">
                                            <div class="flex items-center gap-3 min-w-0">
                                                <app-checkbox [value]="selectedItemsIdsSet.has(item._id)"
                                                    (onChange)="toggleSelect('kbFiles', item)"
                                                    [config]="{ binary: true }" class="flex-shrink-0" />
                                                <div class="flex-shrink-0">
                                                    @if(item.mimeType == "pdf"){
                                                    <i [innerHTML]="SVGS.PDF | sanitizeHtml" alt="" width="24"
                                                        height="24" class="text-red-500"></i>
                                                    }@else if (item.mimeType == "docx") {
                                                    <i [innerHTML]="SVGS.DOCX | sanitizeHtml" alt="" width="24"
                                                        height="24"></i>
                                                    }
                                                </div>
                                                <div class="min-w-0 flex-1">
                                                    <div class="text-sm font-semibold text-gray-900 truncate"
                                                        pTooltip="{{ item.name }}" tooltipPosition="top">
                                                        {{ item.name }}
                                                    </div>
                                                    <div class="text-xs text-gray-500 truncate">{{ item.size }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    }
                                </div>
                                }
                            </div>
                        </p-tabpanel>
                    </p-tabpanels>
                </p-tabs>
            </div>

            <div class="flex flex-col flex-1 min-w-0 overflow-hidden p-4 border-l border-gray-200">
                <h2 class="font-bold text-base text-gray-800 mb-4 flex-shrink-0">Selected files</h2>
                <div class="flex-1 min-h-0 overflow-y-auto pr-2">
                    @if(selectedKbStores.length === 0 && selectedKbFilesForMapping.length === 0){
                    <div class="flex flex-col h-full items-center justify-center text-center">
                        <p class="text-sm text-gray-500">Select files to add them</p>
                    </div>
                    } @else {
                    <div class="flex flex-col gap-4">
                        <!-- Knowledge base section -->
                        @if(selectedKbStores.length > 0){
                        <div>
                            <h3 class="text-sm font-semibold text-gray-900 mb-2">Knowledge base</h3>
                            <div class="space-y-2">
                                <div *ngFor="let item of selectedKbStores"
                                    class="border border-gray-200 rounded-lg p-3 flex-shrink-0 bg-white">
                                    <div class="flex items-center gap-3 min-w-0">
                                        <div class="flex-shrink-0">
                                            <i [innerHTML]="SVGS.KNOWLEDGE_BASE | sanitizeHtml" alt="" width="24"
                                                height="24"></i>
                                        </div>
                                        <div class="min-w-0 flex-1">
                                            <div class="text-sm font-semibold text-gray-900 truncate"
                                                pTooltip="{{ item.name }}" tooltipPosition="top">
                                                {{ item.name }}
                                            </div>
                                            <div class="text-xs text-gray-500 truncate">
                                                {{ item.description || '' }}
                                            </div>
                                        </div>
                                        <span class="text-xs text-gray-500 flex-shrink-0">{{ getKbStoreFileCount(item)
                                            }} files</span>
                                        <button type="button"
                                            class="flex-shrink-0 p-1.5 rounded hover:bg-red-50 text-red-500 transition-colors"
                                            (click)="toggleSelect('kbStores', item)" pTooltip="Remove"
                                            tooltipPosition="top">
                                            <i class="pi pi-trash text-sm"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                        <!-- Files section -->
                        @if(selectedKbFilesForMapping.length > 0){
                        <div>
                            <h3 class="text-sm font-semibold text-gray-900 mb-2">Files</h3>
                            <div class="space-y-2">
                                <div *ngFor="let item of selectedKbFilesForMapping"
                                    class="border border-gray-200 rounded-lg p-3 flex-shrink-0 bg-white">
                                    <div class="flex items-center gap-3 min-w-0">
                                        <div class="flex-shrink-0">
                                            @if(item.mimeType == "pdf"){
                                            <i [innerHTML]="SVGS.PDF | sanitizeHtml" alt="" width="24" height="24"
                                                class="text-red-500"></i>
                                            }@else if (item.mimeType == "docx") {
                                            <i [innerHTML]="SVGS.DOCX | sanitizeHtml" alt="" width="24" height="24"></i>
                                            }
                                        </div>
                                        <div class="min-w-0 flex-1">
                                            <div class="text-sm font-semibold text-gray-900 truncate"
                                                pTooltip="{{ item.name }}" tooltipPosition="top">
                                                {{ item.name }}
                                            </div>
                                            <div class="text-xs text-gray-500 truncate">
                                                {{ item.size }}
                                            </div>
                                        </div>
                                        <button type="button"
                                            class="flex-shrink-0 p-1.5 rounded hover:bg-red-50 text-red-500 transition-colors"
                                            (click)="toggleSelect('kbFiles', item)" pTooltip="Remove"
                                            tooltipPosition="top">
                                            <i class="pi pi-trash text-sm"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                    }
                </div>
            </div>
        </div>
        }
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex gap-2 justify-end">
            <app-button variant="outlined" label="Cancel" severity="contrast" (clicked)="hideMappingDialog()" />
            <app-button variant="filled" label="Upload" severity="primary" (clicked)="mapFiles()"
                [loading]="mappingDialogLoading" />
        </div>
    </ng-template>
</app-dialog>

<ng-template #nameTemplate let-rowData="$implicit">
    <div class="flex items-center gap-2">
        @if(rowData.linkedDocumentType == LINKED_DOCUMENT_TYPE.FILE){
        @if(rowData.linkedDocument.mimeType == "pdf"){
        <i [innerHTML]="SVGS.PDF | sanitizeHtml"></i>
        <span class="text-sm font-medium">{{rowData.linkedDocument.name}}</span>
        }@else if (rowData.linkedDocument.mimeType == "docx") {
        <i [innerHTML]="SVGS.DOCX | sanitizeHtml"></i>
        <span class="text-sm font-medium">{{rowData.linkedDocument.name}}</span>
        }
        }@else if (rowData.linkedDocumentType == LINKED_DOCUMENT_TYPE.KNOWLEDGE_BASE_STORE)
        {
        <div class="flex items-center gap-2 cursor-pointer" (click)="toggleKb(rowData)">
            <i [innerHTML]="SVGS.KNOWLEDGE_BASE | sanitizeHtml"></i>
            <span class="text-sm font-medium">{{rowData.linkedDocument.name}}</span>
        </div>
        }
    </div>
</ng-template>

<ng-template #addedByTemplate let-rowData="$implicit">
    <div class="flex items-center gap-1">
        <app-user-name-display [user]="rowData.createdBy" [variant]="'avatar-name'"></app-user-name-display>
    </div>
</ng-template>

<ng-template #fileSizeTemplate let-rowData="$implicit">
    {{rowData.linkedDocument.size | fileSize}}
</ng-template>

<ng-template #dateTemplate let-rowData="$implicit">
    {{rowData.createdAt | dateFormatter: 'Do MMMM, YYYY'}}
</ng-template>

<ng-template #actionsTemplate let-rowData="$implicit">
    @if(!selectedKnowledgeBase){
    <div class="flex gap-2">
        <i [innerHTML]="SVGS.BULK_DELINK | sanitizeHtml" (click)="delinkFiles(rowData)" pTooltip="Delink"
            class="cursor-pointer" tooltipPosition="bottom"></i>
        @if(rowData.linkedDocumentType == LINKED_DOCUMENT_TYPE.FILE){
        <i [innerHTML]="SVGS.VIEW | sanitizeHtml" (click)="viewFile(rowData)" pTooltip="View" class="cursor-pointer"
            tooltipPosition="bottom"></i>
        }
    </div>
    }
</ng-template>

<ng-template #kbFileNameTemplate let-rowData="$implicit">
    <div class="flex items-center gap-2">
        @if(rowData.file.mimeType == "pdf"){
        <i [innerHTML]="SVGS.PDF | sanitizeHtml" class="flex-shrink-0"></i>
        <span class="text-sm font-medium truncate" pTooltip="{{rowData.file.name}}"
            tooltipPosition="top">{{rowData.file.name}}</span>
        }@else if (rowData.file.mimeType == "docx") {
        <i [innerHTML]="SVGS.DOCX | sanitizeHtml" class="flex-shrink-0"></i>
        <span class="text-sm font-medium truncate" pTooltip="{{rowData.file.name}}"
            tooltipPosition="top">{{rowData.file.name}}</span>
        }@else {
        <i [innerHTML]="SVGS.PDF | sanitizeHtml" class="flex-shrink-0"></i>
        <span class="text-sm font-medium truncate" pTooltip="{{rowData.file.name}}"
            tooltipPosition="top">{{rowData.file.name}}</span>
        }
    </div>
</ng-template>

<ng-template #kbFileAddedByTemplate let-rowData="$implicit">
    <div class="flex items-center gap-1">
        <app-user-name-display [user]="rowData.createdBy" [variant]="'avatar-name'"></app-user-name-display>
    </div>
</ng-template>

<ng-template #kbFileSizeTemplate let-rowData="$implicit">
    {{rowData.file.size | fileSize}}
</ng-template>

<ng-template #kbFileDateTemplate let-rowData="$implicit">
    {{rowData.uploadedAt | dateFormatter: 'Do MMMM, YYYY'}}
</ng-template>

<ng-template #kbFileActionsTemplate let-rowData="$implicit">
    <div class="flex gap-2">
        <i [innerHTML]="SVGS.VIEW | sanitizeHtml" (click)="viewKbFile(rowData)" pTooltip="View"
            class="cursor-pointer"></i>
        <i [innerHTML]="SVGS.BULK_DELINK | sanitizeHtml" (click)="delinkKbFile(rowData)" pTooltip="Delink"
            class="cursor-pointer" tooltipPosition="bottom"></i>
    </div>
</ng-template>

@if(showDelinkFilesDialog){
<app-delete-confirmation [(visible)]="showDelinkFilesDialog"
    [headerText]="delinkFileToRemove ? 'Delink this File?' : 'Delink the files or documents?'"
    [bodyText]="delinkFileToRemove ? 'This document will be removed from the current knowledge Mapping.' : 'Are you sure you want to delink ' + selectedLinkedDocs.length + ' files from the current knowledge mapping?'"
    confirmButtonText="Delink" (onConfirm)="confirmDelinkFiles()">
</app-delete-confirmation>
}

@if(showDelinkKbFileDialog){
<app-delete-confirmation [(visible)]="showDelinkKbFileDialog" headerText="Delink this File?"
    bodyText="This file will be removed from the knowledge base store." confirmButtonText="Delink"
    (onConfirm)="confirmDelinkKbFile()">
</app-delete-confirmation>
}

@if(showDelinkKbFilesDialog){
<app-delete-confirmation [(visible)]="showDelinkKbFilesDialog" headerText="Delink Selected Files?"
    [bodyText]="'Are you sure you want to delink ' + selectedKbFiles.length + ' files from the knowledge base store?'"
    confirmButtonText="Delink" (onConfirm)="confirmDelinkKbFiles()">
</app-delete-confirmation>
}

<app-dialog [(visible)]="showDocumentPreview" [title]="selectedFileName" (closed)="closeDocumentPreview()"
    class="max-w-4xl h-[90vh]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="h-full w-full">
            @if(selectedDocumentFile && selectedDocumentId) {
            <app-document-preview [documentId]="selectedDocumentId" [file]="selectedDocumentFile">
            </app-document-preview>
            }
        </div>
    </ng-template>
</app-dialog>
